<template lang="pug">
div
  v-layout.pt-4(column)
    label: b Geslacht*
    v-radio-group(
      v-model='data.personalModel.sex'
      :error-messages='sexValidationErrors',
      )
      v-layout
        v-radio.mb-0(value='M', label='Man', color='primary')
        v-radio.mb-0(value='F', label='Vrouw', color='primary')

  v-layout.flex-column-phone
    v-layout
      text-field.small(
        label='Voorletters',
        v-model='data.personalModel.initials',
        name='initials',
        mask='A.A.A.A.A.',
        required,
        :error-messages='initialsValidationErrors',
        @change='$v.data.personalModel.initials.$touch()',
        @blur='$v.data.personalModel.initials.$touch()',
        )

      text-field.small.mr-4(
        label='Tussenv.',
        name='insertion',
        v-model='data.personalModel.nameInsertion',
        style='max-width: 80px',
        :error-messages='nameInsertionValidationErrors',
        @change='$v.data.personalModel.nameInsertion.$touch()',
        @blur='$v.data.personalModel.nameInsertion.$touch()',
        )

    text-field.flex-grow-1(
      label='Achternaam',
      v-model='data.personalModel.lastName',
      name='lastname',
      required,
      :error-messages='lastNameValidationErrors',
      @change='$v.data.personalModel.lastName.$touch()',
      @blur='$v.data.personalModel.lastName.$touch()',
      )

  v-layout.flex-column-phone
    DatePicker(
      label='Geboortedatum'
      v-model='data.personalModel.birthdate'
      name='birthdate',
      minimumAge,
      required,
      propName='birthdate',
      @setValid='setValid'
      )

    v-layout(column)
      label: b Nationaliteit*
      v-autocomplete(
        v-model='data.personalModel.nationality'
        name='nationality',
        :items='countryItems',
        item-text='name',
        item-value='short_name',
        required,
        :error-messages='nationalityValidationErrors',
        @change='$v.data.personalModel.nationality.$touch()',
        @blur='$v.data.personalModel.nationality.$touch()',
        solo
        )

  v-layout(column)
    label: b Burgelijke staat*
    v-select(
      v-model='data.personalModel.maritalStatus'
      :items='maritalStatusItems',
      :error-messages='maritalStatusValidationErrors',
      @change='$v.data.personalModel.maritalStatus.$touch()',
      @blur='$v.data.personalModel.maritalStatus.$touch()',
      required,
      solo
      )

  v-layout(column)
    label: b Ben je (ooit) gescheiden en/of alimentatieplichtig?*
    v-select(
      v-model='data.personalModel.alimony'
      :items='yesNoItems',
      :error-messages='alimonyValidationErrors',
      @change='$v.data.personalModel.alimony.$touch()',
      @blur='$v.data.personalModel.alimony.$touch()',
      required,
      solo
      )

  v-layout.flex-column-phone
    text-field.flex-grow-1(
      label='Aantal inwonende kinderen (onder de 21 jaar)',
      v-model.number='data.personalModel.childrenInResident',
      type='number',
      min='0',
      required,
      :error-messages='childrenInResidentValidationErrors',
      @change='$v.data.personalModel.childrenInResident.$touch()',
      @blur='$v.data.personalModel.childrenInResident.$touch()'
      )

    text-field(
      v-if='data.personalModel.childrenInResident > 0',
      label='Leeftijd jongste kind',
      min='0',
      v-model.number='data.personalModel.childrenInResidentMinimumAge',
      type='number',
      required,
      :error-messages='childrenInResidentMinimumAgeValidationErrors',
      @change='$v.data.personalModel.childrenInResidentMinimumAge.$touch()',
      @blur='$v.data.personalModel.childrenInResidentMinimumAge.$touch()',
      )

  v-layout.flex-column-phone
    text-field.flex-grow-1(
      label='Email',
      v-model='data.personalModel.email',
      name='email',
      required,
      :error-messages='emailValidationErrors',
      @change='$v.data.personalModel.email.$touch()',
      @blur='$v.data.personalModel.email.$touch()',
      )

    text-field.flex-grow-1(
      label='Telefoon',
      name='phone',
      placeholder='+31 6 123 123 12',
      v-model='data.personalModel.phone',
      mask='+## # ## ### ###',
      required,
      :error-messages='phoneValidationErrors',
      @change='$v.data.personalModel.phone.$touch()',
      @blur='$v.data.personalModel.phone.$touch()',
      )

  v-layout.flex-column-phone
    text-field(
      label='Postcode',
      name='postalCode',
      mask='#### AA',
      placeholder='1234 AB',
      v-model='data.personalModel.postalCode',
      required,
      :error-messages='postalCodeValidationErrors',
      @change='$v.data.personalModel.postalCode.$touch()',
      @blur='$v.data.personalModel.postalCode.$touch()',
      )

    v-layout
      text-field(
        label='Huisnummer',
        name='streetNumber',
        v-model='data.personalModel.streetNumber',
        required,
        :error-messages='streetNumberValidationErrors',
        @change='$v.data.personalModel.streetNumber.$touch()',
        @blur='$v.data.personalModel.streetNumber.$touch()',
        )

      text-field(
        label='Toevoeging',
        v-model='data.personalModel.streetNumberAddition',
        :error-messages='streetNumberAdditionValidationErrors',
        @change='$v.data.personalModel.streetNumberAddition.$touch()',
        @blur='$v.data.personalModel.streetNumberAddition.$touch()',
        )

  v-layout.flex-column-phone
    text-field.flex-grow-1(
      label='Straatnaam',
      name='streetName',
      v-model='data.personalModel.streetName',
      required,
      :error-messages='streetNameValidationErrors',
      @change='$v.data.personalModel.streetName.$touch()',
      @blur='$v.data.personalModel.streetName.$touch()',
      )

    text-field.flex-grow-1(
      label='Plaats',
      v-model='data.personalModel.city',
      name='city',
      required,
      :error-messages='cityValidationErrors',
      @change='$v.data.personalModel.city.$touch()',
      @blur='$v.data.personalModel.city.$touch()',
      )

  template(v-if='hasPartner')
    v-divider.mb-4

    h3 Persoonlijke gegevens partner

    v-layout.mt-3(column)
      label: b Geslacht*
      v-radio-group(v-model='data.partnerModel.sex')
        v-layout
          v-radio.mb-0(value='M', label='Man', color='primary')
          v-radio.mb-0(value='F', label='Vrouw', color='primary')

    v-layout.flex-column-phone
      v-layout
        text-field.small(
          label='Voorletters',
          v-model='data.partnerModel.initials',
          mask='A.A.A.A.A.',
          required,
          :error-messages='partnerInitialsValidationErrors',
          @change='$v.data.partnerModel.initials.$touch()',
          @blur='$v.data.partnerModel.initials.$touch()',
          )

        text-field.small(
          label='Tussenv.',
          v-model='data.partnerModel.nameInsertion',
          style='max-width: 80px',
          :error-messages='partnerNameInsertionValidationErrors',
          @change='$v.data.partnerModel.nameInsertion.$touch()',
          @blur='$v.data.partnerModel.nameInsertion.$touch()',
          )

      text-field.flex-grow-1(
        label='Achternaam',
        v-model='data.partnerModel.lastName',
        required,
        :error-messages='partnerLastNameValidationErrors',
        @change='$v.data.partnerModel.lastName.$touch()',
        @blur='$v.data.partnerModel.lastName.$touch()',
        )

    v-layout.flex-column-phone
      DatePicker(
        v-model='data.partnerModel.birthdate',
        label='Geboortedatum',
        required,
        minimumAge,
        propName='partnerBirthdate',
        @setValid='setValid'
        )

      v-layout(column)
        label: b Nationaliteit*
        v-autocomplete(
          v-model='data.partnerModel.nationality'
          :items='countryItems',
          item-text='name',
          item-value='short_name',
          required,
          :error-messages='partnerNationalityValidationErrors',
          @change='$v.data.partnerModel.nationality.$touch()',
          @blur='$v.data.partnerModel.nationality.$touch()',
          solo
          )

    v-layout(column)
      label: b Ben je (ooit) gescheiden en/of alimentatieplichtig?*
      v-select(
        v-model='data.partnerModel.alimony'
        :items='yesNoItems',
        :error-messages='partnerAlimonyValidationErrors',
        @change='$v.data.partnerModel.alimony.$touch()',
        @blur='$v.data.partnerModel.alimony.$touch()',
        required,
        solo
        )
</template>

<script>
import { yesNoDropdownItems } from './helpers/template'
// import { required, email, requiredIf, decimal } from 'vuelidate/lib/validators'
import required from 'vuelidate/src/validators/required'
import email from 'vuelidate/src/validators/email'
import requiredIf from 'vuelidate/src/validators/requiredIf'
import decimal from 'vuelidate/src/validators/decimal'
import { fullPhoneRegex } from './helpers/regex'

export default {
  props: {
    value: Object
  },

  data () {
    return {
      data: this.value,

      birthdateValid: false,
      partnerBirthdateValid: false,

      countryItems: require('./assets/countries.json'),
      yesNoItems: yesNoDropdownItems,
      maritalStatusItems: [{ text: 'Ongehuwd', value: 'single' }, { text: 'Gehuwd', value: 'married' }, { text: 'Samenwonend', value: 'living_together' }, { text: 'Geregistreerd partnerschap', value: 'registered_partnership' }],

      hasPartner: false // Workaround because for some reason hasPartner getter won't update
    }
  },

  methods: {
    setValid ({ propName, valid }) {
      this[propName + 'Valid'] = valid
    }
  },

  computed: {
    sexValidationErrors () {
      const errors = []
      if (!this.$v.data.personalModel.sex.$dirty) return errors
      !this.$v.data.personalModel.sex.required && errors.push('Dit veld is verplicht')
      return errors
    },

    initialsValidationErrors () {
      const errors = []
      if (!this.$v.data.personalModel.initials.$dirty) return errors
      !this.$v.data.personalModel.initials.required && errors.push('Dit veld is verplicht')
      return errors
    },

    nameInsertionValidationErrors () {
      const errors = []
      if (!this.$v.data.personalModel.nameInsertion.$dirty) return errors
      return errors
    },

    lastNameValidationErrors () {
      const errors = []
      if (!this.$v.data.personalModel.lastName.$dirty) return errors
      !this.$v.data.personalModel.lastName.required && errors.push('Dit veld is verplicht')
      return errors
    },

    maritalStatusValidationErrors () {
      const errors = []
      if (!this.$v.data.personalModel.maritalStatus.$dirty) return errors
      !this.$v.data.personalModel.maritalStatus.required && errors.push('Dit veld is verplicht')
      return errors
    },

    alimonyValidationErrors () {
      const errors = []
      if (!this.$v.data.personalModel.alimony.$dirty) return errors
      !this.$v.data.personalModel.alimony.required && errors.push('Dit veld is verplicht')
      return errors
    },

    childrenInResidentValidationErrors () {
      const errors = []
      if (!this.$v.data.personalModel.childrenInResident.$dirty) return errors
      !this.$v.data.personalModel.childrenInResident.decimal && errors.push('Dit moet een getal zijn')
      !this.$v.data.personalModel.childrenInResident.required && errors.push('Dit veld is verplicht')
      return errors
    },

    childrenInResidentMinimumAgeValidationErrors () {
      const errors = []
      if (!this.$v.data.personalModel.childrenInResidentMinimumAge.$dirty) return errors
      !this.$v.data.personalModel.childrenInResidentMinimumAge.decimal && errors.push('Dit moet een getal zijn')
      !this.$v.data.personalModel.childrenInResidentMinimumAge.required && errors.push('Dit veld is verplicht')
      return errors
    },

    emailValidationErrors () {
      const errors = []
      if (!this.$v.data.personalModel.email.$dirty) return errors
      !this.$v.data.personalModel.email.required && errors.push('Dit veld is verplicht')
      !this.$v.data.personalModel.email.email && errors.push('Dit is geen geldig email adres')
      return errors
    },

    phoneValidationErrors () {
      const errors = []
      if (!this.$v.data.personalModel.phone.$dirty) return errors
      !this.$v.data.personalModel.phone.required && errors.push('Dit veld is verplicht')
      !this.$v.data.personalModel.phone.regex && errors.push('Gebruik het volgende formaat: +31 6 12 123 123')
      return errors
    },

    nationalityValidationErrors () {
      const errors = []
      if (!this.$v.data.personalModel.nationality.$dirty) return errors
      !this.$v.data.personalModel.nationality.required && errors.push('Dit veld is verplicht')
      return errors
    },

    postalCodeValidationErrors () {
      const errors = []
      if (!this.$v.data.personalModel.postalCode.$dirty) return errors
      !this.$v.data.personalModel.postalCode.required && errors.push('Dit veld is verplicht')
      return errors
    },

    streetNumberValidationErrors () {
      const errors = []
      if (!this.$v.data.personalModel.streetNumber.$dirty) return errors
      !this.$v.data.personalModel.streetNumber.required && errors.push('Dit veld is verplicht')
      return errors
    },

    streetNumberAdditionValidationErrors () {
      const errors = []
      if (!this.$v.data.personalModel.streetNumberAddition.$dirty) return errors
      return errors
    },

    streetNameValidationErrors () {
      const errors = []
      if (!this.$v.data.personalModel.streetName.$dirty) return errors
      !this.$v.data.personalModel.streetName.required && errors.push('Dit veld is verplicht')
      return errors
    },

    cityValidationErrors () {
      const errors = []
      if (!this.$v.data.personalModel.city.$dirty) return errors
      !this.$v.data.personalModel.city.required && errors.push('Dit veld is verplicht')
      return errors
    },

    partnerSexValidationErrors () {
      const errors = []
      if (!this.$v.data.partnerModel.sex.$dirty) return errors
      !this.$v.data.partnerModel.sex.required && errors.push('Dit veld is verplicht')
      return errors
    },

    partnerInitialsValidationErrors () {
      const errors = []
      if (!this.$v.data.partnerModel.initials.$dirty) return errors
      !this.$v.data.partnerModel.initials.required && errors.push('Dit veld is verplicht')
      return errors
    },

    partnerNameInsertionValidationErrors () {
      const errors = []
      if (!this.$v.data.partnerModel.nameInsertion.$dirty) return errors
      return errors
    },

    partnerLastNameValidationErrors () {
      const errors = []
      if (!this.$v.data.partnerModel.lastName.$dirty) return errors
      !this.$v.data.partnerModel.lastName.required && errors.push('Dit veld is verplicht')
      return errors
    },

    partnerNationalityValidationErrors () {
      const errors = []
      if (!this.$v.data.partnerModel.nationality.$dirty) return errors
      !this.$v.data.partnerModel.nationality.required && errors.push('Dit veld is verplicht')
      return errors
    },

    partnerAlimonyValidationErrors () {
      const errors = []
      if (!this.$v.data.partnerModel.alimony.$dirty) return errors
      !this.$v.data.partnerModel.alimony.required && errors.push('Dit veld is verplicht')
      return errors
    }
  },

  validations: {
    data: {
      personalModel: {
        sex: {
          required
        },

        postalCode: {
          required
        },

        streetNumber: {
          required
        },

        streetNumberAddition: {},

        streetName: {
          required
        },

        city: {
          required
        },

        initials: {
          required
        },

        nameInsertion: {},

        lastName: {
          required
        },

        birthdate: {
          valid: function (v) {
            return this.birthdateValid
          }
        },

        email: {
          required,
          email
        },

        phone: {
          required,
          regex: (v) => fullPhoneRegex.test(v)
        },

        nationality: {
          required
        },

        maritalStatus: {
          required
        },

        alimony: {
          required
        },

        childrenInResident: {
          required,
          decimal
        },

        childrenInResidentMinimumAge: {
          required: requiredIf(personalModel => personalModel.childrenInResident > 0),
          decimal
        }
      },

      partnerModel: {
        sex: {
          required: requiredIf(function () {
            return this.hasPartner
          })
        },

        initials: {
          required: requiredIf(function () {
            return this.hasPartner
          })
        },

        nameInsertion: {},

        lastName: {
          required: requiredIf(function () {
            return this.hasPartner
          })
        },

        birthdate: {
          valid: function (v, vm) {
            if (!this.hasPartner) {
              return true
            }

            return this.partnerBirthdateValid
          }
        },

        nationality: {
          required: requiredIf(function () {
            return this.hasPartner
          })
        },

        alimony: {
          required: requiredIf(function () {
            return this.hasPartner
          })
        }
      }
    }
  },

  watch: {
    '$v.$invalid': {
      handler: function (invalid) {
        this.$emit('setValid', {
          modelName: 'personalModel',
          valid: !invalid
        })
      },
      deep: true,
      immediate: true
    },

    value (v) {
      this.data = v
    },

    data: { // TODO run frontend test that confirms partner fields show when maritalStatus is set (after setting another field!!)
      handler: function (v) {
        this.$emit('input', v)

        this.hasPartner = v.personalModel.maritalStatus && v.personalModel.maritalStatus !== 'single'
      },
      deep: true
    },

    hasPartner (v) {
      if (v) this.data.partnerModel = {}
      else this.$delete(this.data, 'partnerModel')
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
